import { api } from "./api";

export const CreateBatch = async (data) => {
  return await api.post("createBatch", data); // ✅ correct endpoint, NO /:id
};

export const getBatchList = async (addUrl = "") => {
  let url = `/batch/list?${addUrl}`;
  return await api.get(url);
};

export const getBatchNCourseList = async (addUrl = "") => {
  let url = `/batch/list?${addUrl}`;
  return await api.get(url);
};
export const BatchlistBySession = async (sessionId = "") => {
  const url = sessionId ? `/batches?session_id=${sessionId}` : `/batches`;

  return await api.get(url);
};

export const deleteBatch = async (id) => {
  return await api.get(`batch/delete/${id}`);
};
export const ViewBatch = async (id, addUrl = "") => {
  let url = `/batch/info/${id}?${addUrl}`;
  return await api.get(url);
};

export const viewlist = async (addUrl = "") => {
  let url = `/batch/list?${addUrl}`;
  return await api.get(url);
};
export const UpdateBatchstatus = async (data) => {
  return await api.post(`update/batch/staus`, data);
};
export const UpdateBatchstudentstatus = async (data) => {
  return await api.post(`/batch/student/status`, data);
};

export const updateBatch = async (data) => {
  return await api.post(`UpdateBatch`, data);
};

export const BatchParmotePost = async (data) => {
  return api.post(`promote/batch`, data);
};
